import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import inventoriesReducer from "./slices/inventories/inventorySlice"; //importing the reducer
import cartReducer from "./slices/cart/cartSlice"
import userReducer from "./slices/users/userSlice";
import clientReducer from "./slices/client/clientSlice";
import proposalInventoryReducer from "./slices/proposalInventories/proposalInventorySlice";
import blockInventoryReducer from "./slices/blockInventories/blockInventorySlice"
// const inventoriesPersistConfig = {
//     key : "inventoriesList",
//     storage
// }

const proposalInventoriesPersistConfig = {
    key : "proposalList",
    storage
}
const blockedInventoriesPersistConfig = {
    key : "blockInventory",
    storage
}


const cartPersistConfig = {
    key : "cartSpace",
    storage
}

const usersPersistConfig={
    key:"user",
    storage
}

const clientPersistConfig={
    key:"client",
    storage
}

// const persistedInventoriesReducer = persistReducer(inventoriesPersistConfig,inventoriesReducer)
const persistedCartReducer = persistReducer(cartPersistConfig,cartReducer)
const persistedUserReducer = persistReducer(usersPersistConfig,userReducer);
const persistClientReducer = persistReducer(clientPersistConfig,clientReducer);
const persistProposalInventoryReducer = persistReducer(proposalInventoriesPersistConfig,proposalInventoryReducer);
const persistBlockInventoryReducer = persistReducer(blockedInventoriesPersistConfig,blockInventoryReducer);


const store = configureStore({
    reducer:{     //something similar to combine reducers
        'inventoriesList':inventoriesReducer,
        'cartSpace':persistedCartReducer,
        'user':persistedUserReducer,
        'client':persistClientReducer,
        'proposalList':persistProposalInventoryReducer,
        'blockedInventory':persistBlockInventoryReducer
    },
})  

export const persistor = persistStore(store);

export default store;